/*
 * The amount of time autosave should wait before saving a model.  This allows multiple saves to be queued.
 */
let AUTOSAVE_TIMER: number = 3;

/* AUTOSAVE_DELAY is a2 second delay before saving */
const AUTOSAVE_DELAY: number = 2000;
export {
    AUTOSAVE_DELAY,
    AUTOSAVE_TIMER
}